import { Grid, Typography, Tooltip, IconButton, Link } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import InfoIcon from '@mui/icons-material/Info';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Summary = (props) => {
  return (
    <Accordion
      square
      defaultExpanded
      sx={{
        boxShadow: '0px 5px 25px rgba(0,0,0,0.15)',
        padding: { xs: '0.5rem', md: '1rem' },
        borderRadius: 5,
      }}>
      <AccordionSummary
        expandIcon={
          <Tooltip title='Click to find out more!'>
            <IconButton>
              <InfoIcon />
            </IconButton>
          </Tooltip>
        }>
        <Typography
          variant='h4'
          component='h2'
          sx={{
            fontWeight: 'bold',
            fontStyle: 'italic',
            maxWidth: { xs: '100%', sm: '100%' },
            mx: '1.0rem',
            textAlign: 'left',
          }}>
          Hey, I'm {props.text.name}.
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container direction='row' justify='flex-start' alignItems='flex-end'>
          <Grid container xs={12} spacing={0}>
            <Grid item xs={12} lg={6}>
              <List
                sx={{
                  maxWidth: { xs: '100%', sm: '100%' },
                }}>
                <ListItem>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'bold',
                      maxWidth: { xs: '100%', sm: '70%' },
                      mr: '1.0rem',
                    }}>
                    Industry:
                  </Typography>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'regular',
                      maxWidth: { xs: '100%', sm: '70%' },
                    }}>
                    {props.text.industry}
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'bold',
                      maxWidth: { xs: '100%', sm: '70%' },
                      mr: '1.0rem',
                    }}>
                    Revenue:
                  </Typography>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'regular',
                      maxWidth: { xs: '100%', sm: '70%' },
                    }}>
                    {props.text.revenue}
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'bold',
                      maxWidth: { xs: '100%', sm: '70%' },
                      mr: '1.0rem',
                    }}>
                    (No. of) Founders:
                  </Typography>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'regular',
                      maxWidth: { xs: '100%', sm: '70%' },
                    }}>
                    {props.text.numOfFounders}
                  </Typography>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} lg={6}>
              <List
                sx={{
                  maxWidth: { xs: '100%', sm: '100%' },
                }}>
                <ListItem>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'bold',
                      maxWidth: { xs: '100%', sm: '70%' },
                      mr: '1.0rem',
                    }}>
                    Team Size:
                  </Typography>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'regular',
                      maxWidth: { xs: '100%', sm: '70%' },
                    }}>
                    {props.text.teamSize}
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'bold',
                      maxWidth: { xs: '100%', sm: '70%' },
                      mr: '1.0rem',
                    }}>
                    Tools Used:
                  </Typography>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'regular',
                      maxWidth: { xs: '100%', sm: '70%' },
                      wordWrap: 'break-word',
                    }}>
                    {props.text.tools}
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'bold',
                      maxWidth: { xs: '100%', sm: '70%' },
                      mr: '1.0rem',
                    }}>
                    Socials:
                  </Typography>
                  <Typography
                    variant='body2'
                    component='h2'
                    sx={{
                      fontWeight: 'regular',
                      maxWidth: { xs: '60%', sm: '80%' },
                      wordWrap: 'break-word',
                      '.MuiSvgIcon-root': {
                        margin: '0.5rem',
                      },
                    }}>
                    {props.text.socials
                      .map((link) => {
                        const rootLink = link.includes('http') ? link : '//' + link;
                        if (link.includes('instagram'))
                          return (
                            <Link button component='a' target='_blank' href={rootLink}>
                              <InstagramIcon />
                            </Link>
                          );
                        else if (link.includes('twitter'))
                          return (
                            <Link button component='a' target='_blank' href={rootLink}>
                              <TwitterIcon />
                            </Link>
                          );
                        else if (link.includes('youtube'))
                          return (
                            <Link button component='a' target='_blank' href={rootLink}>
                              <YouTubeIcon />
                            </Link>
                          );
                        else if (link.includes('facebook'))
                          return (
                            <Link button component='a' target='_blank' href={rootLink}>
                              <FacebookIcon />
                            </Link>
                          );
                        else if (link.includes('linkedin') || link.includes('linked.in'))
                          return (
                            <Link button component='a' target='_blank' href={rootLink}>
                              <LinkedInIcon />
                            </Link>
                          );
                        else
                          return (
                            <ListItem button component='a' target='_blank' href={rootLink}>
                              <Typography
                                variant='body2'
                                component='h2'
                                sx={{
                                  fontWeight: 'regular',
                                  textDecoration: 'underline',
                                  maxWidth: '100%',
                                  ml: '0rem',
                                }}>
                                {link}
                              </Typography>
                            </ListItem>
                          );
                      })
                      .sort((a, b) => (a.type === Link ? -1 : 0))}
                  </Typography>
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default Summary;
